/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const at = $root.at = (() => {

    /**
     * Namespace at.
     * @exports at
     * @namespace
     */
    const at = {};

    at.hotelmeister = (function() {

        /**
         * Namespace hotelmeister.
         * @memberof at
         * @namespace
         */
        const hotelmeister = {};

        hotelmeister.protobuf = (function() {

            /**
             * Namespace protobuf.
             * @memberof at.hotelmeister
             * @namespace
             */
            const protobuf = {};

            protobuf.backend = (function() {

                /**
                 * Namespace backend.
                 * @memberof at.hotelmeister.protobuf
                 * @namespace
                 */
                const backend = {};

                backend.RoomPlanReservation = (function() {

                    /**
                     * Properties of a RoomPlanReservation.
                     * @memberof at.hotelmeister.protobuf.backend
                     * @interface IRoomPlanReservation
                     * @property {string|null} [reservationId] RoomPlanReservation reservationId
                     * @property {string|null} [checkInDate] RoomPlanReservation checkInDate
                     * @property {string|null} [checkOutDate] RoomPlanReservation checkOutDate
                     * @property {number|null} [numberOfNights] RoomPlanReservation numberOfNights
                     * @property {string|null} [displayNameOverride] RoomPlanReservation displayNameOverride
                     * @property {string|null} [roomNumber] RoomPlanReservation roomNumber
                     * @property {string|null} [roomTypeId] RoomPlanReservation roomTypeId
                     * @property {number|null} [amount] RoomPlanReservation amount
                     * @property {number|null} [shoppingCartAmount] RoomPlanReservation shoppingCartAmount
                     * @property {string|null} [currency] RoomPlanReservation currency
                     * @property {string|null} [internalComment] RoomPlanReservation internalComment
                     * @property {string|null} [status] RoomPlanReservation status
                     * @property {string|null} [type] RoomPlanReservation type
                     * @property {string|null} [requestExpirationDate] RoomPlanReservation requestExpirationDate
                     * @property {string|null} [colorCategoryCssClass] RoomPlanReservation colorCategoryCssClass
                     * @property {number|null} [numAdults] RoomPlanReservation numAdults
                     * @property {number|null} [numChildren] RoomPlanReservation numChildren
                     * @property {string|null} [sourceName] RoomPlanReservation sourceName
                     * @property {string|null} [guestProfileId] RoomPlanReservation guestProfileId
                     * @property {string|null} [guestProfileType] RoomPlanReservation guestProfileType
                     * @property {string|null} [guestProfileFirstName] RoomPlanReservation guestProfileFirstName
                     * @property {string|null} [guestProfileLastName] RoomPlanReservation guestProfileLastName
                     * @property {string|null} [guestProfileCompanyName] RoomPlanReservation guestProfileCompanyName
                     * @property {string|null} [guestProfileNamePrefix] RoomPlanReservation guestProfileNamePrefix
                     * @property {string|null} [guestProfileNameSuffix] RoomPlanReservation guestProfileNameSuffix
                     * @property {string|null} [guestProfileMiddleName] RoomPlanReservation guestProfileMiddleName
                     * @property {string|null} [companyName] RoomPlanReservation companyName
                     * @property {string|null} [travelAgentCompanyName] RoomPlanReservation travelAgentCompanyName
                     * @property {boolean|null} [roomNumberLocked] RoomPlanReservation roomNumberLocked
                     * @property {string|null} [shortInternalComment] RoomPlanReservation shortInternalComment
                     * @property {Object.<string,string>|null} [additionalFields] RoomPlanReservation additionalFields
                     * @property {string|null} [ratePlanId] RoomPlanReservation ratePlanId
                     */

                    /**
                     * Constructs a new RoomPlanReservation.
                     * @memberof at.hotelmeister.protobuf.backend
                     * @classdesc Represents a RoomPlanReservation.
                     * @implements IRoomPlanReservation
                     * @constructor
                     * @param {at.hotelmeister.protobuf.backend.IRoomPlanReservation=} [properties] Properties to set
                     */
                    function RoomPlanReservation(properties) {
                        this.additionalFields = {};
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * RoomPlanReservation reservationId.
                     * @member {string} reservationId
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.reservationId = "";

                    /**
                     * RoomPlanReservation checkInDate.
                     * @member {string} checkInDate
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.checkInDate = "";

                    /**
                     * RoomPlanReservation checkOutDate.
                     * @member {string} checkOutDate
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.checkOutDate = "";

                    /**
                     * RoomPlanReservation numberOfNights.
                     * @member {number} numberOfNights
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.numberOfNights = 0;

                    /**
                     * RoomPlanReservation displayNameOverride.
                     * @member {string} displayNameOverride
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.displayNameOverride = "";

                    /**
                     * RoomPlanReservation roomNumber.
                     * @member {string} roomNumber
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.roomNumber = "";

                    /**
                     * RoomPlanReservation roomTypeId.
                     * @member {string} roomTypeId
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.roomTypeId = "";

                    /**
                     * RoomPlanReservation amount.
                     * @member {number} amount
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.amount = 0;

                    /**
                     * RoomPlanReservation shoppingCartAmount.
                     * @member {number} shoppingCartAmount
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.shoppingCartAmount = 0;

                    /**
                     * RoomPlanReservation currency.
                     * @member {string} currency
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.currency = "";

                    /**
                     * RoomPlanReservation internalComment.
                     * @member {string} internalComment
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.internalComment = "";

                    /**
                     * RoomPlanReservation status.
                     * @member {string} status
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.status = "";

                    /**
                     * RoomPlanReservation type.
                     * @member {string} type
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.type = "";

                    /**
                     * RoomPlanReservation requestExpirationDate.
                     * @member {string} requestExpirationDate
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.requestExpirationDate = "";

                    /**
                     * RoomPlanReservation colorCategoryCssClass.
                     * @member {string} colorCategoryCssClass
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.colorCategoryCssClass = "";

                    /**
                     * RoomPlanReservation numAdults.
                     * @member {number} numAdults
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.numAdults = 0;

                    /**
                     * RoomPlanReservation numChildren.
                     * @member {number} numChildren
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.numChildren = 0;

                    /**
                     * RoomPlanReservation sourceName.
                     * @member {string} sourceName
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.sourceName = "";

                    /**
                     * RoomPlanReservation guestProfileId.
                     * @member {string} guestProfileId
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.guestProfileId = "";

                    /**
                     * RoomPlanReservation guestProfileType.
                     * @member {string} guestProfileType
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.guestProfileType = "";

                    /**
                     * RoomPlanReservation guestProfileFirstName.
                     * @member {string} guestProfileFirstName
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.guestProfileFirstName = "";

                    /**
                     * RoomPlanReservation guestProfileLastName.
                     * @member {string} guestProfileLastName
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.guestProfileLastName = "";

                    /**
                     * RoomPlanReservation guestProfileCompanyName.
                     * @member {string} guestProfileCompanyName
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.guestProfileCompanyName = "";

                    /**
                     * RoomPlanReservation guestProfileNamePrefix.
                     * @member {string} guestProfileNamePrefix
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.guestProfileNamePrefix = "";

                    /**
                     * RoomPlanReservation guestProfileNameSuffix.
                     * @member {string} guestProfileNameSuffix
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.guestProfileNameSuffix = "";

                    /**
                     * RoomPlanReservation guestProfileMiddleName.
                     * @member {string} guestProfileMiddleName
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.guestProfileMiddleName = "";

                    /**
                     * RoomPlanReservation companyName.
                     * @member {string} companyName
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.companyName = "";

                    /**
                     * RoomPlanReservation travelAgentCompanyName.
                     * @member {string} travelAgentCompanyName
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.travelAgentCompanyName = "";

                    /**
                     * RoomPlanReservation roomNumberLocked.
                     * @member {boolean} roomNumberLocked
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.roomNumberLocked = false;

                    /**
                     * RoomPlanReservation shortInternalComment.
                     * @member {string} shortInternalComment
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.shortInternalComment = "";

                    /**
                     * RoomPlanReservation additionalFields.
                     * @member {Object.<string,string>} additionalFields
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.additionalFields = $util.emptyObject;

                    /**
                     * RoomPlanReservation ratePlanId.
                     * @member {string} ratePlanId
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     */
                    RoomPlanReservation.prototype.ratePlanId = "";

                    /**
                     * Creates a new RoomPlanReservation instance using the specified properties.
                     * @function create
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.IRoomPlanReservation=} [properties] Properties to set
                     * @returns {at.hotelmeister.protobuf.backend.RoomPlanReservation} RoomPlanReservation instance
                     */
                    RoomPlanReservation.create = function create(properties) {
                        return new RoomPlanReservation(properties);
                    };

                    /**
                     * Encodes the specified RoomPlanReservation message. Does not implicitly {@link at.hotelmeister.protobuf.backend.RoomPlanReservation.verify|verify} messages.
                     * @function encode
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.IRoomPlanReservation} message RoomPlanReservation message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RoomPlanReservation.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.reservationId != null && Object.hasOwnProperty.call(message, "reservationId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.reservationId);
                        if (message.checkInDate != null && Object.hasOwnProperty.call(message, "checkInDate"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.checkInDate);
                        if (message.checkOutDate != null && Object.hasOwnProperty.call(message, "checkOutDate"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.checkOutDate);
                        if (message.numberOfNights != null && Object.hasOwnProperty.call(message, "numberOfNights"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.numberOfNights);
                        if (message.displayNameOverride != null && Object.hasOwnProperty.call(message, "displayNameOverride"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.displayNameOverride);
                        if (message.roomNumber != null && Object.hasOwnProperty.call(message, "roomNumber"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.roomNumber);
                        if (message.roomTypeId != null && Object.hasOwnProperty.call(message, "roomTypeId"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.roomTypeId);
                        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                            writer.uint32(/* id 8, wireType 1 =*/65).double(message.amount);
                        if (message.shoppingCartAmount != null && Object.hasOwnProperty.call(message, "shoppingCartAmount"))
                            writer.uint32(/* id 9, wireType 1 =*/73).double(message.shoppingCartAmount);
                        if (message.currency != null && Object.hasOwnProperty.call(message, "currency"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.currency);
                        if (message.internalComment != null && Object.hasOwnProperty.call(message, "internalComment"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.internalComment);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.status);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 13, wireType 2 =*/106).string(message.type);
                        if (message.requestExpirationDate != null && Object.hasOwnProperty.call(message, "requestExpirationDate"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.requestExpirationDate);
                        if (message.colorCategoryCssClass != null && Object.hasOwnProperty.call(message, "colorCategoryCssClass"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.colorCategoryCssClass);
                        if (message.numAdults != null && Object.hasOwnProperty.call(message, "numAdults"))
                            writer.uint32(/* id 16, wireType 0 =*/128).int32(message.numAdults);
                        if (message.numChildren != null && Object.hasOwnProperty.call(message, "numChildren"))
                            writer.uint32(/* id 17, wireType 0 =*/136).int32(message.numChildren);
                        if (message.sourceName != null && Object.hasOwnProperty.call(message, "sourceName"))
                            writer.uint32(/* id 18, wireType 2 =*/146).string(message.sourceName);
                        if (message.guestProfileId != null && Object.hasOwnProperty.call(message, "guestProfileId"))
                            writer.uint32(/* id 19, wireType 2 =*/154).string(message.guestProfileId);
                        if (message.guestProfileType != null && Object.hasOwnProperty.call(message, "guestProfileType"))
                            writer.uint32(/* id 20, wireType 2 =*/162).string(message.guestProfileType);
                        if (message.guestProfileFirstName != null && Object.hasOwnProperty.call(message, "guestProfileFirstName"))
                            writer.uint32(/* id 21, wireType 2 =*/170).string(message.guestProfileFirstName);
                        if (message.guestProfileLastName != null && Object.hasOwnProperty.call(message, "guestProfileLastName"))
                            writer.uint32(/* id 22, wireType 2 =*/178).string(message.guestProfileLastName);
                        if (message.guestProfileCompanyName != null && Object.hasOwnProperty.call(message, "guestProfileCompanyName"))
                            writer.uint32(/* id 23, wireType 2 =*/186).string(message.guestProfileCompanyName);
                        if (message.guestProfileNamePrefix != null && Object.hasOwnProperty.call(message, "guestProfileNamePrefix"))
                            writer.uint32(/* id 24, wireType 2 =*/194).string(message.guestProfileNamePrefix);
                        if (message.guestProfileNameSuffix != null && Object.hasOwnProperty.call(message, "guestProfileNameSuffix"))
                            writer.uint32(/* id 25, wireType 2 =*/202).string(message.guestProfileNameSuffix);
                        if (message.guestProfileMiddleName != null && Object.hasOwnProperty.call(message, "guestProfileMiddleName"))
                            writer.uint32(/* id 26, wireType 2 =*/210).string(message.guestProfileMiddleName);
                        if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                            writer.uint32(/* id 27, wireType 2 =*/218).string(message.companyName);
                        if (message.travelAgentCompanyName != null && Object.hasOwnProperty.call(message, "travelAgentCompanyName"))
                            writer.uint32(/* id 28, wireType 2 =*/226).string(message.travelAgentCompanyName);
                        if (message.roomNumberLocked != null && Object.hasOwnProperty.call(message, "roomNumberLocked"))
                            writer.uint32(/* id 29, wireType 0 =*/232).bool(message.roomNumberLocked);
                        if (message.shortInternalComment != null && Object.hasOwnProperty.call(message, "shortInternalComment"))
                            writer.uint32(/* id 30, wireType 2 =*/242).string(message.shortInternalComment);
                        if (message.additionalFields != null && Object.hasOwnProperty.call(message, "additionalFields"))
                            for (let keys = Object.keys(message.additionalFields), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 31, wireType 2 =*/250).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.additionalFields[keys[i]]).ldelim();
                        if (message.ratePlanId != null && Object.hasOwnProperty.call(message, "ratePlanId"))
                            writer.uint32(/* id 32, wireType 2 =*/258).string(message.ratePlanId);
                        return writer;
                    };

                    /**
                     * Encodes the specified RoomPlanReservation message, length delimited. Does not implicitly {@link at.hotelmeister.protobuf.backend.RoomPlanReservation.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.IRoomPlanReservation} message RoomPlanReservation message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RoomPlanReservation.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a RoomPlanReservation message from the specified reader or buffer.
                     * @function decode
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {at.hotelmeister.protobuf.backend.RoomPlanReservation} RoomPlanReservation
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RoomPlanReservation.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.at.hotelmeister.protobuf.backend.RoomPlanReservation(), key, value;
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.reservationId = reader.string();
                                break;
                            case 2:
                                message.checkInDate = reader.string();
                                break;
                            case 3:
                                message.checkOutDate = reader.string();
                                break;
                            case 4:
                                message.numberOfNights = reader.int32();
                                break;
                            case 5:
                                message.displayNameOverride = reader.string();
                                break;
                            case 6:
                                message.roomNumber = reader.string();
                                break;
                            case 7:
                                message.roomTypeId = reader.string();
                                break;
                            case 8:
                                message.amount = reader.double();
                                break;
                            case 9:
                                message.shoppingCartAmount = reader.double();
                                break;
                            case 10:
                                message.currency = reader.string();
                                break;
                            case 11:
                                message.internalComment = reader.string();
                                break;
                            case 12:
                                message.status = reader.string();
                                break;
                            case 13:
                                message.type = reader.string();
                                break;
                            case 14:
                                message.requestExpirationDate = reader.string();
                                break;
                            case 15:
                                message.colorCategoryCssClass = reader.string();
                                break;
                            case 16:
                                message.numAdults = reader.int32();
                                break;
                            case 17:
                                message.numChildren = reader.int32();
                                break;
                            case 18:
                                message.sourceName = reader.string();
                                break;
                            case 19:
                                message.guestProfileId = reader.string();
                                break;
                            case 20:
                                message.guestProfileType = reader.string();
                                break;
                            case 21:
                                message.guestProfileFirstName = reader.string();
                                break;
                            case 22:
                                message.guestProfileLastName = reader.string();
                                break;
                            case 23:
                                message.guestProfileCompanyName = reader.string();
                                break;
                            case 24:
                                message.guestProfileNamePrefix = reader.string();
                                break;
                            case 25:
                                message.guestProfileNameSuffix = reader.string();
                                break;
                            case 26:
                                message.guestProfileMiddleName = reader.string();
                                break;
                            case 27:
                                message.companyName = reader.string();
                                break;
                            case 28:
                                message.travelAgentCompanyName = reader.string();
                                break;
                            case 29:
                                message.roomNumberLocked = reader.bool();
                                break;
                            case 30:
                                message.shortInternalComment = reader.string();
                                break;
                            case 31:
                                if (message.additionalFields === $util.emptyObject)
                                    message.additionalFields = {};
                                let end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    let tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.additionalFields[key] = value;
                                break;
                            case 32:
                                message.ratePlanId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a RoomPlanReservation message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {at.hotelmeister.protobuf.backend.RoomPlanReservation} RoomPlanReservation
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RoomPlanReservation.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a RoomPlanReservation message.
                     * @function verify
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RoomPlanReservation.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.reservationId != null && message.hasOwnProperty("reservationId"))
                            if (!$util.isString(message.reservationId))
                                return "reservationId: string expected";
                        if (message.checkInDate != null && message.hasOwnProperty("checkInDate"))
                            if (!$util.isString(message.checkInDate))
                                return "checkInDate: string expected";
                        if (message.checkOutDate != null && message.hasOwnProperty("checkOutDate"))
                            if (!$util.isString(message.checkOutDate))
                                return "checkOutDate: string expected";
                        if (message.numberOfNights != null && message.hasOwnProperty("numberOfNights"))
                            if (!$util.isInteger(message.numberOfNights))
                                return "numberOfNights: integer expected";
                        if (message.displayNameOverride != null && message.hasOwnProperty("displayNameOverride"))
                            if (!$util.isString(message.displayNameOverride))
                                return "displayNameOverride: string expected";
                        if (message.roomNumber != null && message.hasOwnProperty("roomNumber"))
                            if (!$util.isString(message.roomNumber))
                                return "roomNumber: string expected";
                        if (message.roomTypeId != null && message.hasOwnProperty("roomTypeId"))
                            if (!$util.isString(message.roomTypeId))
                                return "roomTypeId: string expected";
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            if (typeof message.amount !== "number")
                                return "amount: number expected";
                        if (message.shoppingCartAmount != null && message.hasOwnProperty("shoppingCartAmount"))
                            if (typeof message.shoppingCartAmount !== "number")
                                return "shoppingCartAmount: number expected";
                        if (message.currency != null && message.hasOwnProperty("currency"))
                            if (!$util.isString(message.currency))
                                return "currency: string expected";
                        if (message.internalComment != null && message.hasOwnProperty("internalComment"))
                            if (!$util.isString(message.internalComment))
                                return "internalComment: string expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            if (!$util.isString(message.status))
                                return "status: string expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            if (!$util.isString(message.type))
                                return "type: string expected";
                        if (message.requestExpirationDate != null && message.hasOwnProperty("requestExpirationDate"))
                            if (!$util.isString(message.requestExpirationDate))
                                return "requestExpirationDate: string expected";
                        if (message.colorCategoryCssClass != null && message.hasOwnProperty("colorCategoryCssClass"))
                            if (!$util.isString(message.colorCategoryCssClass))
                                return "colorCategoryCssClass: string expected";
                        if (message.numAdults != null && message.hasOwnProperty("numAdults"))
                            if (!$util.isInteger(message.numAdults))
                                return "numAdults: integer expected";
                        if (message.numChildren != null && message.hasOwnProperty("numChildren"))
                            if (!$util.isInteger(message.numChildren))
                                return "numChildren: integer expected";
                        if (message.sourceName != null && message.hasOwnProperty("sourceName"))
                            if (!$util.isString(message.sourceName))
                                return "sourceName: string expected";
                        if (message.guestProfileId != null && message.hasOwnProperty("guestProfileId"))
                            if (!$util.isString(message.guestProfileId))
                                return "guestProfileId: string expected";
                        if (message.guestProfileType != null && message.hasOwnProperty("guestProfileType"))
                            if (!$util.isString(message.guestProfileType))
                                return "guestProfileType: string expected";
                        if (message.guestProfileFirstName != null && message.hasOwnProperty("guestProfileFirstName"))
                            if (!$util.isString(message.guestProfileFirstName))
                                return "guestProfileFirstName: string expected";
                        if (message.guestProfileLastName != null && message.hasOwnProperty("guestProfileLastName"))
                            if (!$util.isString(message.guestProfileLastName))
                                return "guestProfileLastName: string expected";
                        if (message.guestProfileCompanyName != null && message.hasOwnProperty("guestProfileCompanyName"))
                            if (!$util.isString(message.guestProfileCompanyName))
                                return "guestProfileCompanyName: string expected";
                        if (message.guestProfileNamePrefix != null && message.hasOwnProperty("guestProfileNamePrefix"))
                            if (!$util.isString(message.guestProfileNamePrefix))
                                return "guestProfileNamePrefix: string expected";
                        if (message.guestProfileNameSuffix != null && message.hasOwnProperty("guestProfileNameSuffix"))
                            if (!$util.isString(message.guestProfileNameSuffix))
                                return "guestProfileNameSuffix: string expected";
                        if (message.guestProfileMiddleName != null && message.hasOwnProperty("guestProfileMiddleName"))
                            if (!$util.isString(message.guestProfileMiddleName))
                                return "guestProfileMiddleName: string expected";
                        if (message.companyName != null && message.hasOwnProperty("companyName"))
                            if (!$util.isString(message.companyName))
                                return "companyName: string expected";
                        if (message.travelAgentCompanyName != null && message.hasOwnProperty("travelAgentCompanyName"))
                            if (!$util.isString(message.travelAgentCompanyName))
                                return "travelAgentCompanyName: string expected";
                        if (message.roomNumberLocked != null && message.hasOwnProperty("roomNumberLocked"))
                            if (typeof message.roomNumberLocked !== "boolean")
                                return "roomNumberLocked: boolean expected";
                        if (message.shortInternalComment != null && message.hasOwnProperty("shortInternalComment"))
                            if (!$util.isString(message.shortInternalComment))
                                return "shortInternalComment: string expected";
                        if (message.additionalFields != null && message.hasOwnProperty("additionalFields")) {
                            if (!$util.isObject(message.additionalFields))
                                return "additionalFields: object expected";
                            let key = Object.keys(message.additionalFields);
                            for (let i = 0; i < key.length; ++i)
                                if (!$util.isString(message.additionalFields[key[i]]))
                                    return "additionalFields: string{k:string} expected";
                        }
                        if (message.ratePlanId != null && message.hasOwnProperty("ratePlanId"))
                            if (!$util.isString(message.ratePlanId))
                                return "ratePlanId: string expected";
                        return null;
                    };

                    /**
                     * Creates a RoomPlanReservation message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {at.hotelmeister.protobuf.backend.RoomPlanReservation} RoomPlanReservation
                     */
                    RoomPlanReservation.fromObject = function fromObject(object) {
                        if (object instanceof $root.at.hotelmeister.protobuf.backend.RoomPlanReservation)
                            return object;
                        let message = new $root.at.hotelmeister.protobuf.backend.RoomPlanReservation();
                        if (object.reservationId != null)
                            message.reservationId = String(object.reservationId);
                        if (object.checkInDate != null)
                            message.checkInDate = String(object.checkInDate);
                        if (object.checkOutDate != null)
                            message.checkOutDate = String(object.checkOutDate);
                        if (object.numberOfNights != null)
                            message.numberOfNights = object.numberOfNights | 0;
                        if (object.displayNameOverride != null)
                            message.displayNameOverride = String(object.displayNameOverride);
                        if (object.roomNumber != null)
                            message.roomNumber = String(object.roomNumber);
                        if (object.roomTypeId != null)
                            message.roomTypeId = String(object.roomTypeId);
                        if (object.amount != null)
                            message.amount = Number(object.amount);
                        if (object.shoppingCartAmount != null)
                            message.shoppingCartAmount = Number(object.shoppingCartAmount);
                        if (object.currency != null)
                            message.currency = String(object.currency);
                        if (object.internalComment != null)
                            message.internalComment = String(object.internalComment);
                        if (object.status != null)
                            message.status = String(object.status);
                        if (object.type != null)
                            message.type = String(object.type);
                        if (object.requestExpirationDate != null)
                            message.requestExpirationDate = String(object.requestExpirationDate);
                        if (object.colorCategoryCssClass != null)
                            message.colorCategoryCssClass = String(object.colorCategoryCssClass);
                        if (object.numAdults != null)
                            message.numAdults = object.numAdults | 0;
                        if (object.numChildren != null)
                            message.numChildren = object.numChildren | 0;
                        if (object.sourceName != null)
                            message.sourceName = String(object.sourceName);
                        if (object.guestProfileId != null)
                            message.guestProfileId = String(object.guestProfileId);
                        if (object.guestProfileType != null)
                            message.guestProfileType = String(object.guestProfileType);
                        if (object.guestProfileFirstName != null)
                            message.guestProfileFirstName = String(object.guestProfileFirstName);
                        if (object.guestProfileLastName != null)
                            message.guestProfileLastName = String(object.guestProfileLastName);
                        if (object.guestProfileCompanyName != null)
                            message.guestProfileCompanyName = String(object.guestProfileCompanyName);
                        if (object.guestProfileNamePrefix != null)
                            message.guestProfileNamePrefix = String(object.guestProfileNamePrefix);
                        if (object.guestProfileNameSuffix != null)
                            message.guestProfileNameSuffix = String(object.guestProfileNameSuffix);
                        if (object.guestProfileMiddleName != null)
                            message.guestProfileMiddleName = String(object.guestProfileMiddleName);
                        if (object.companyName != null)
                            message.companyName = String(object.companyName);
                        if (object.travelAgentCompanyName != null)
                            message.travelAgentCompanyName = String(object.travelAgentCompanyName);
                        if (object.roomNumberLocked != null)
                            message.roomNumberLocked = Boolean(object.roomNumberLocked);
                        if (object.shortInternalComment != null)
                            message.shortInternalComment = String(object.shortInternalComment);
                        if (object.additionalFields) {
                            if (typeof object.additionalFields !== "object")
                                throw TypeError(".at.hotelmeister.protobuf.backend.RoomPlanReservation.additionalFields: object expected");
                            message.additionalFields = {};
                            for (let keys = Object.keys(object.additionalFields), i = 0; i < keys.length; ++i)
                                message.additionalFields[keys[i]] = String(object.additionalFields[keys[i]]);
                        }
                        if (object.ratePlanId != null)
                            message.ratePlanId = String(object.ratePlanId);
                        return message;
                    };

                    /**
                     * Creates a plain object from a RoomPlanReservation message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.RoomPlanReservation} message RoomPlanReservation
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RoomPlanReservation.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.objects || options.defaults)
                            object.additionalFields = {};
                        if (options.defaults) {
                            object.reservationId = "";
                            object.checkInDate = "";
                            object.checkOutDate = "";
                            object.numberOfNights = 0;
                            object.displayNameOverride = "";
                            object.roomNumber = "";
                            object.roomTypeId = "";
                            object.amount = 0;
                            object.shoppingCartAmount = 0;
                            object.currency = "";
                            object.internalComment = "";
                            object.status = "";
                            object.type = "";
                            object.requestExpirationDate = "";
                            object.colorCategoryCssClass = "";
                            object.numAdults = 0;
                            object.numChildren = 0;
                            object.sourceName = "";
                            object.guestProfileId = "";
                            object.guestProfileType = "";
                            object.guestProfileFirstName = "";
                            object.guestProfileLastName = "";
                            object.guestProfileCompanyName = "";
                            object.guestProfileNamePrefix = "";
                            object.guestProfileNameSuffix = "";
                            object.guestProfileMiddleName = "";
                            object.companyName = "";
                            object.travelAgentCompanyName = "";
                            object.roomNumberLocked = false;
                            object.shortInternalComment = "";
                            object.ratePlanId = "";
                        }
                        if (message.reservationId != null && message.hasOwnProperty("reservationId"))
                            object.reservationId = message.reservationId;
                        if (message.checkInDate != null && message.hasOwnProperty("checkInDate"))
                            object.checkInDate = message.checkInDate;
                        if (message.checkOutDate != null && message.hasOwnProperty("checkOutDate"))
                            object.checkOutDate = message.checkOutDate;
                        if (message.numberOfNights != null && message.hasOwnProperty("numberOfNights"))
                            object.numberOfNights = message.numberOfNights;
                        if (message.displayNameOverride != null && message.hasOwnProperty("displayNameOverride"))
                            object.displayNameOverride = message.displayNameOverride;
                        if (message.roomNumber != null && message.hasOwnProperty("roomNumber"))
                            object.roomNumber = message.roomNumber;
                        if (message.roomTypeId != null && message.hasOwnProperty("roomTypeId"))
                            object.roomTypeId = message.roomTypeId;
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
                        if (message.shoppingCartAmount != null && message.hasOwnProperty("shoppingCartAmount"))
                            object.shoppingCartAmount = options.json && !isFinite(message.shoppingCartAmount) ? String(message.shoppingCartAmount) : message.shoppingCartAmount;
                        if (message.currency != null && message.hasOwnProperty("currency"))
                            object.currency = message.currency;
                        if (message.internalComment != null && message.hasOwnProperty("internalComment"))
                            object.internalComment = message.internalComment;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = message.status;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = message.type;
                        if (message.requestExpirationDate != null && message.hasOwnProperty("requestExpirationDate"))
                            object.requestExpirationDate = message.requestExpirationDate;
                        if (message.colorCategoryCssClass != null && message.hasOwnProperty("colorCategoryCssClass"))
                            object.colorCategoryCssClass = message.colorCategoryCssClass;
                        if (message.numAdults != null && message.hasOwnProperty("numAdults"))
                            object.numAdults = message.numAdults;
                        if (message.numChildren != null && message.hasOwnProperty("numChildren"))
                            object.numChildren = message.numChildren;
                        if (message.sourceName != null && message.hasOwnProperty("sourceName"))
                            object.sourceName = message.sourceName;
                        if (message.guestProfileId != null && message.hasOwnProperty("guestProfileId"))
                            object.guestProfileId = message.guestProfileId;
                        if (message.guestProfileType != null && message.hasOwnProperty("guestProfileType"))
                            object.guestProfileType = message.guestProfileType;
                        if (message.guestProfileFirstName != null && message.hasOwnProperty("guestProfileFirstName"))
                            object.guestProfileFirstName = message.guestProfileFirstName;
                        if (message.guestProfileLastName != null && message.hasOwnProperty("guestProfileLastName"))
                            object.guestProfileLastName = message.guestProfileLastName;
                        if (message.guestProfileCompanyName != null && message.hasOwnProperty("guestProfileCompanyName"))
                            object.guestProfileCompanyName = message.guestProfileCompanyName;
                        if (message.guestProfileNamePrefix != null && message.hasOwnProperty("guestProfileNamePrefix"))
                            object.guestProfileNamePrefix = message.guestProfileNamePrefix;
                        if (message.guestProfileNameSuffix != null && message.hasOwnProperty("guestProfileNameSuffix"))
                            object.guestProfileNameSuffix = message.guestProfileNameSuffix;
                        if (message.guestProfileMiddleName != null && message.hasOwnProperty("guestProfileMiddleName"))
                            object.guestProfileMiddleName = message.guestProfileMiddleName;
                        if (message.companyName != null && message.hasOwnProperty("companyName"))
                            object.companyName = message.companyName;
                        if (message.travelAgentCompanyName != null && message.hasOwnProperty("travelAgentCompanyName"))
                            object.travelAgentCompanyName = message.travelAgentCompanyName;
                        if (message.roomNumberLocked != null && message.hasOwnProperty("roomNumberLocked"))
                            object.roomNumberLocked = message.roomNumberLocked;
                        if (message.shortInternalComment != null && message.hasOwnProperty("shortInternalComment"))
                            object.shortInternalComment = message.shortInternalComment;
                        let keys2;
                        if (message.additionalFields && (keys2 = Object.keys(message.additionalFields)).length) {
                            object.additionalFields = {};
                            for (let j = 0; j < keys2.length; ++j)
                                object.additionalFields[keys2[j]] = message.additionalFields[keys2[j]];
                        }
                        if (message.ratePlanId != null && message.hasOwnProperty("ratePlanId"))
                            object.ratePlanId = message.ratePlanId;
                        return object;
                    };

                    /**
                     * Converts this RoomPlanReservation to JSON.
                     * @function toJSON
                     * @memberof at.hotelmeister.protobuf.backend.RoomPlanReservation
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RoomPlanReservation.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return RoomPlanReservation;
                })();

                backend.RoomTypePlanResponse = (function() {

                    /**
                     * Properties of a RoomTypePlanResponse.
                     * @memberof at.hotelmeister.protobuf.backend
                     * @interface IRoomTypePlanResponse
                     * @property {Object.<string,at.hotelmeister.protobuf.backend.RoomTypePlanResponse.IByRoomTypeAvailability>|null} [ByRoomType] RoomTypePlanResponse ByRoomType
                     * @property {Object.<string,number>|null} [Total] RoomTypePlanResponse Total
                     */

                    /**
                     * Constructs a new RoomTypePlanResponse.
                     * @memberof at.hotelmeister.protobuf.backend
                     * @classdesc Represents a RoomTypePlanResponse.
                     * @implements IRoomTypePlanResponse
                     * @constructor
                     * @param {at.hotelmeister.protobuf.backend.IRoomTypePlanResponse=} [properties] Properties to set
                     */
                    function RoomTypePlanResponse(properties) {
                        this.ByRoomType = {};
                        this.Total = {};
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * RoomTypePlanResponse ByRoomType.
                     * @member {Object.<string,at.hotelmeister.protobuf.backend.RoomTypePlanResponse.IByRoomTypeAvailability>} ByRoomType
                     * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse
                     * @instance
                     */
                    RoomTypePlanResponse.prototype.ByRoomType = $util.emptyObject;

                    /**
                     * RoomTypePlanResponse Total.
                     * @member {Object.<string,number>} Total
                     * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse
                     * @instance
                     */
                    RoomTypePlanResponse.prototype.Total = $util.emptyObject;

                    /**
                     * Creates a new RoomTypePlanResponse instance using the specified properties.
                     * @function create
                     * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.IRoomTypePlanResponse=} [properties] Properties to set
                     * @returns {at.hotelmeister.protobuf.backend.RoomTypePlanResponse} RoomTypePlanResponse instance
                     */
                    RoomTypePlanResponse.create = function create(properties) {
                        return new RoomTypePlanResponse(properties);
                    };

                    /**
                     * Encodes the specified RoomTypePlanResponse message. Does not implicitly {@link at.hotelmeister.protobuf.backend.RoomTypePlanResponse.verify|verify} messages.
                     * @function encode
                     * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.IRoomTypePlanResponse} message RoomTypePlanResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RoomTypePlanResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.ByRoomType != null && Object.hasOwnProperty.call(message, "ByRoomType"))
                            for (let keys = Object.keys(message.ByRoomType), i = 0; i < keys.length; ++i) {
                                writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                                $root.at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability.encode(message.ByRoomType[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                            }
                        if (message.Total != null && Object.hasOwnProperty.call(message, "Total"))
                            for (let keys = Object.keys(message.Total), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).int32(message.Total[keys[i]]).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified RoomTypePlanResponse message, length delimited. Does not implicitly {@link at.hotelmeister.protobuf.backend.RoomTypePlanResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.IRoomTypePlanResponse} message RoomTypePlanResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RoomTypePlanResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a RoomTypePlanResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {at.hotelmeister.protobuf.backend.RoomTypePlanResponse} RoomTypePlanResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RoomTypePlanResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.at.hotelmeister.protobuf.backend.RoomTypePlanResponse(), key, value;
                        while (reader.pos < end) {
                            let end2 = -1;
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (message.ByRoomType === $util.emptyObject)
                                    message.ByRoomType = {};
                                end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = null;
                                while (reader.pos < end2) {
                                    let tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = $root.at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability.decode(reader, reader.uint32());
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.ByRoomType[key] = value;
                                break;
                            case 2:
                                if (message.Total === $util.emptyObject)
                                    message.Total = {};
                                end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = 0;
                                while (reader.pos < end2) {
                                    let tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.int32();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.Total[key] = value;
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a RoomTypePlanResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {at.hotelmeister.protobuf.backend.RoomTypePlanResponse} RoomTypePlanResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RoomTypePlanResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a RoomTypePlanResponse message.
                     * @function verify
                     * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RoomTypePlanResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.ByRoomType != null && message.hasOwnProperty("ByRoomType")) {
                            if (!$util.isObject(message.ByRoomType))
                                return "ByRoomType: object expected";
                            let key = Object.keys(message.ByRoomType);
                            for (let i = 0; i < key.length; ++i) {
                                let error = $root.at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability.verify(message.ByRoomType[key[i]]);
                                if (error)
                                    return "ByRoomType." + error;
                            }
                        }
                        if (message.Total != null && message.hasOwnProperty("Total")) {
                            if (!$util.isObject(message.Total))
                                return "Total: object expected";
                            let key = Object.keys(message.Total);
                            for (let i = 0; i < key.length; ++i)
                                if (!$util.isInteger(message.Total[key[i]]))
                                    return "Total: integer{k:string} expected";
                        }
                        return null;
                    };

                    /**
                     * Creates a RoomTypePlanResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {at.hotelmeister.protobuf.backend.RoomTypePlanResponse} RoomTypePlanResponse
                     */
                    RoomTypePlanResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.at.hotelmeister.protobuf.backend.RoomTypePlanResponse)
                            return object;
                        let message = new $root.at.hotelmeister.protobuf.backend.RoomTypePlanResponse();
                        if (object.ByRoomType) {
                            if (typeof object.ByRoomType !== "object")
                                throw TypeError(".at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomType: object expected");
                            message.ByRoomType = {};
                            for (let keys = Object.keys(object.ByRoomType), i = 0; i < keys.length; ++i) {
                                if (typeof object.ByRoomType[keys[i]] !== "object")
                                    throw TypeError(".at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomType: object expected");
                                message.ByRoomType[keys[i]] = $root.at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability.fromObject(object.ByRoomType[keys[i]]);
                            }
                        }
                        if (object.Total) {
                            if (typeof object.Total !== "object")
                                throw TypeError(".at.hotelmeister.protobuf.backend.RoomTypePlanResponse.Total: object expected");
                            message.Total = {};
                            for (let keys = Object.keys(object.Total), i = 0; i < keys.length; ++i)
                                message.Total[keys[i]] = object.Total[keys[i]] | 0;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a RoomTypePlanResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.RoomTypePlanResponse} message RoomTypePlanResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RoomTypePlanResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.objects || options.defaults) {
                            object.ByRoomType = {};
                            object.Total = {};
                        }
                        let keys2;
                        if (message.ByRoomType && (keys2 = Object.keys(message.ByRoomType)).length) {
                            object.ByRoomType = {};
                            for (let j = 0; j < keys2.length; ++j)
                                object.ByRoomType[keys2[j]] = $root.at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability.toObject(message.ByRoomType[keys2[j]], options);
                        }
                        if (message.Total && (keys2 = Object.keys(message.Total)).length) {
                            object.Total = {};
                            for (let j = 0; j < keys2.length; ++j)
                                object.Total[keys2[j]] = message.Total[keys2[j]];
                        }
                        return object;
                    };

                    /**
                     * Converts this RoomTypePlanResponse to JSON.
                     * @function toJSON
                     * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RoomTypePlanResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    RoomTypePlanResponse.ByRoomTypeAvailability = (function() {

                        /**
                         * Properties of a ByRoomTypeAvailability.
                         * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse
                         * @interface IByRoomTypeAvailability
                         * @property {Object.<string,number>|null} [value] ByRoomTypeAvailability value
                         */

                        /**
                         * Constructs a new ByRoomTypeAvailability.
                         * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse
                         * @classdesc Represents a ByRoomTypeAvailability.
                         * @implements IByRoomTypeAvailability
                         * @constructor
                         * @param {at.hotelmeister.protobuf.backend.RoomTypePlanResponse.IByRoomTypeAvailability=} [properties] Properties to set
                         */
                        function ByRoomTypeAvailability(properties) {
                            this.value = {};
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * ByRoomTypeAvailability value.
                         * @member {Object.<string,number>} value
                         * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability
                         * @instance
                         */
                        ByRoomTypeAvailability.prototype.value = $util.emptyObject;

                        /**
                         * Creates a new ByRoomTypeAvailability instance using the specified properties.
                         * @function create
                         * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.RoomTypePlanResponse.IByRoomTypeAvailability=} [properties] Properties to set
                         * @returns {at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability} ByRoomTypeAvailability instance
                         */
                        ByRoomTypeAvailability.create = function create(properties) {
                            return new ByRoomTypeAvailability(properties);
                        };

                        /**
                         * Encodes the specified ByRoomTypeAvailability message. Does not implicitly {@link at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability.verify|verify} messages.
                         * @function encode
                         * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.RoomTypePlanResponse.IByRoomTypeAvailability} message ByRoomTypeAvailability message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ByRoomTypeAvailability.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                                for (let keys = Object.keys(message.value), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).int32(message.value[keys[i]]).ldelim();
                            return writer;
                        };

                        /**
                         * Encodes the specified ByRoomTypeAvailability message, length delimited. Does not implicitly {@link at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.RoomTypePlanResponse.IByRoomTypeAvailability} message ByRoomTypeAvailability message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ByRoomTypeAvailability.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a ByRoomTypeAvailability message from the specified reader or buffer.
                         * @function decode
                         * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability} ByRoomTypeAvailability
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ByRoomTypeAvailability.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability(), key, value;
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (message.value === $util.emptyObject)
                                        message.value = {};
                                    let end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = 0;
                                    while (reader.pos < end2) {
                                        let tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.int32();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.value[key] = value;
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a ByRoomTypeAvailability message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability} ByRoomTypeAvailability
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ByRoomTypeAvailability.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a ByRoomTypeAvailability message.
                         * @function verify
                         * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ByRoomTypeAvailability.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.value != null && message.hasOwnProperty("value")) {
                                if (!$util.isObject(message.value))
                                    return "value: object expected";
                                let key = Object.keys(message.value);
                                for (let i = 0; i < key.length; ++i)
                                    if (!$util.isInteger(message.value[key[i]]))
                                        return "value: integer{k:string} expected";
                            }
                            return null;
                        };

                        /**
                         * Creates a ByRoomTypeAvailability message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability} ByRoomTypeAvailability
                         */
                        ByRoomTypeAvailability.fromObject = function fromObject(object) {
                            if (object instanceof $root.at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability)
                                return object;
                            let message = new $root.at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability();
                            if (object.value) {
                                if (typeof object.value !== "object")
                                    throw TypeError(".at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability.value: object expected");
                                message.value = {};
                                for (let keys = Object.keys(object.value), i = 0; i < keys.length; ++i)
                                    message.value[keys[i]] = object.value[keys[i]] | 0;
                            }
                            return message;
                        };

                        /**
                         * Creates a plain object from a ByRoomTypeAvailability message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability} message ByRoomTypeAvailability
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ByRoomTypeAvailability.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.objects || options.defaults)
                                object.value = {};
                            let keys2;
                            if (message.value && (keys2 = Object.keys(message.value)).length) {
                                object.value = {};
                                for (let j = 0; j < keys2.length; ++j)
                                    object.value[keys2[j]] = message.value[keys2[j]];
                            }
                            return object;
                        };

                        /**
                         * Converts this ByRoomTypeAvailability to JSON.
                         * @function toJSON
                         * @memberof at.hotelmeister.protobuf.backend.RoomTypePlanResponse.ByRoomTypeAvailability
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ByRoomTypeAvailability.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        return ByRoomTypeAvailability;
                    })();

                    return RoomTypePlanResponse;
                })();

                backend.ResponseEnvelope = (function() {

                    /**
                     * Properties of a ResponseEnvelope.
                     * @memberof at.hotelmeister.protobuf.backend
                     * @interface IResponseEnvelope
                     * @property {string|null} [type] ResponseEnvelope type
                     * @property {Array.<Uint8Array>|null} [data] ResponseEnvelope data
                     * @property {Array.<at.hotelmeister.protobuf.backend.ResponseEnvelope.IError>|null} [error] ResponseEnvelope error
                     * @property {Array.<at.hotelmeister.protobuf.backend.ResponseEnvelope.IWarning>|null} [warning] ResponseEnvelope warning
                     * @property {number|null} [version] ResponseEnvelope version
                     * @property {boolean|null} [single] ResponseEnvelope single
                     */

                    /**
                     * Constructs a new ResponseEnvelope.
                     * @memberof at.hotelmeister.protobuf.backend
                     * @classdesc Represents a ResponseEnvelope.
                     * @implements IResponseEnvelope
                     * @constructor
                     * @param {at.hotelmeister.protobuf.backend.IResponseEnvelope=} [properties] Properties to set
                     */
                    function ResponseEnvelope(properties) {
                        this.data = [];
                        this.error = [];
                        this.warning = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ResponseEnvelope type.
                     * @member {string} type
                     * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                     * @instance
                     */
                    ResponseEnvelope.prototype.type = "";

                    /**
                     * ResponseEnvelope data.
                     * @member {Array.<Uint8Array>} data
                     * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                     * @instance
                     */
                    ResponseEnvelope.prototype.data = $util.emptyArray;

                    /**
                     * ResponseEnvelope error.
                     * @member {Array.<at.hotelmeister.protobuf.backend.ResponseEnvelope.IError>} error
                     * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                     * @instance
                     */
                    ResponseEnvelope.prototype.error = $util.emptyArray;

                    /**
                     * ResponseEnvelope warning.
                     * @member {Array.<at.hotelmeister.protobuf.backend.ResponseEnvelope.IWarning>} warning
                     * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                     * @instance
                     */
                    ResponseEnvelope.prototype.warning = $util.emptyArray;

                    /**
                     * ResponseEnvelope version.
                     * @member {number} version
                     * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                     * @instance
                     */
                    ResponseEnvelope.prototype.version = 0;

                    /**
                     * ResponseEnvelope single.
                     * @member {boolean} single
                     * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                     * @instance
                     */
                    ResponseEnvelope.prototype.single = false;

                    /**
                     * Creates a new ResponseEnvelope instance using the specified properties.
                     * @function create
                     * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.IResponseEnvelope=} [properties] Properties to set
                     * @returns {at.hotelmeister.protobuf.backend.ResponseEnvelope} ResponseEnvelope instance
                     */
                    ResponseEnvelope.create = function create(properties) {
                        return new ResponseEnvelope(properties);
                    };

                    /**
                     * Encodes the specified ResponseEnvelope message. Does not implicitly {@link at.hotelmeister.protobuf.backend.ResponseEnvelope.verify|verify} messages.
                     * @function encode
                     * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.IResponseEnvelope} message ResponseEnvelope message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ResponseEnvelope.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
                        if (message.data != null && message.data.length)
                            for (let i = 0; i < message.data.length; ++i)
                                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data[i]);
                        if (message.error != null && message.error.length)
                            for (let i = 0; i < message.error.length; ++i)
                                $root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Error.encode(message.error[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.warning != null && message.warning.length)
                            for (let i = 0; i < message.warning.length; ++i)
                                $root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning.encode(message.warning[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.version);
                        if (message.single != null && Object.hasOwnProperty.call(message, "single"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.single);
                        return writer;
                    };

                    /**
                     * Encodes the specified ResponseEnvelope message, length delimited. Does not implicitly {@link at.hotelmeister.protobuf.backend.ResponseEnvelope.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.IResponseEnvelope} message ResponseEnvelope message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ResponseEnvelope.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a ResponseEnvelope message from the specified reader or buffer.
                     * @function decode
                     * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {at.hotelmeister.protobuf.backend.ResponseEnvelope} ResponseEnvelope
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ResponseEnvelope.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.at.hotelmeister.protobuf.backend.ResponseEnvelope();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.type = reader.string();
                                break;
                            case 2:
                                if (!(message.data && message.data.length))
                                    message.data = [];
                                message.data.push(reader.bytes());
                                break;
                            case 3:
                                if (!(message.error && message.error.length))
                                    message.error = [];
                                message.error.push($root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Error.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                if (!(message.warning && message.warning.length))
                                    message.warning = [];
                                message.warning.push($root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning.decode(reader, reader.uint32()));
                                break;
                            case 5:
                                message.version = reader.int32();
                                break;
                            case 6:
                                message.single = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a ResponseEnvelope message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {at.hotelmeister.protobuf.backend.ResponseEnvelope} ResponseEnvelope
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ResponseEnvelope.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a ResponseEnvelope message.
                     * @function verify
                     * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ResponseEnvelope.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            if (!$util.isString(message.type))
                                return "type: string expected";
                        if (message.data != null && message.hasOwnProperty("data")) {
                            if (!Array.isArray(message.data))
                                return "data: array expected";
                            for (let i = 0; i < message.data.length; ++i)
                                if (!(message.data[i] && typeof message.data[i].length === "number" || $util.isString(message.data[i])))
                                    return "data: buffer[] expected";
                        }
                        if (message.error != null && message.hasOwnProperty("error")) {
                            if (!Array.isArray(message.error))
                                return "error: array expected";
                            for (let i = 0; i < message.error.length; ++i) {
                                let error = $root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Error.verify(message.error[i]);
                                if (error)
                                    return "error." + error;
                            }
                        }
                        if (message.warning != null && message.hasOwnProperty("warning")) {
                            if (!Array.isArray(message.warning))
                                return "warning: array expected";
                            for (let i = 0; i < message.warning.length; ++i) {
                                let error = $root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning.verify(message.warning[i]);
                                if (error)
                                    return "warning." + error;
                            }
                        }
                        if (message.version != null && message.hasOwnProperty("version"))
                            if (!$util.isInteger(message.version))
                                return "version: integer expected";
                        if (message.single != null && message.hasOwnProperty("single"))
                            if (typeof message.single !== "boolean")
                                return "single: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a ResponseEnvelope message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {at.hotelmeister.protobuf.backend.ResponseEnvelope} ResponseEnvelope
                     */
                    ResponseEnvelope.fromObject = function fromObject(object) {
                        if (object instanceof $root.at.hotelmeister.protobuf.backend.ResponseEnvelope)
                            return object;
                        let message = new $root.at.hotelmeister.protobuf.backend.ResponseEnvelope();
                        if (object.type != null)
                            message.type = String(object.type);
                        if (object.data) {
                            if (!Array.isArray(object.data))
                                throw TypeError(".at.hotelmeister.protobuf.backend.ResponseEnvelope.data: array expected");
                            message.data = [];
                            for (let i = 0; i < object.data.length; ++i)
                                if (typeof object.data[i] === "string")
                                    $util.base64.decode(object.data[i], message.data[i] = $util.newBuffer($util.base64.length(object.data[i])), 0);
                                else if (object.data[i].length)
                                    message.data[i] = object.data[i];
                        }
                        if (object.error) {
                            if (!Array.isArray(object.error))
                                throw TypeError(".at.hotelmeister.protobuf.backend.ResponseEnvelope.error: array expected");
                            message.error = [];
                            for (let i = 0; i < object.error.length; ++i) {
                                if (typeof object.error[i] !== "object")
                                    throw TypeError(".at.hotelmeister.protobuf.backend.ResponseEnvelope.error: object expected");
                                message.error[i] = $root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Error.fromObject(object.error[i]);
                            }
                        }
                        if (object.warning) {
                            if (!Array.isArray(object.warning))
                                throw TypeError(".at.hotelmeister.protobuf.backend.ResponseEnvelope.warning: array expected");
                            message.warning = [];
                            for (let i = 0; i < object.warning.length; ++i) {
                                if (typeof object.warning[i] !== "object")
                                    throw TypeError(".at.hotelmeister.protobuf.backend.ResponseEnvelope.warning: object expected");
                                message.warning[i] = $root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning.fromObject(object.warning[i]);
                            }
                        }
                        if (object.version != null)
                            message.version = object.version | 0;
                        if (object.single != null)
                            message.single = Boolean(object.single);
                        return message;
                    };

                    /**
                     * Creates a plain object from a ResponseEnvelope message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.ResponseEnvelope} message ResponseEnvelope
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ResponseEnvelope.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults) {
                            object.data = [];
                            object.error = [];
                            object.warning = [];
                        }
                        if (options.defaults) {
                            object.type = "";
                            object.version = 0;
                            object.single = false;
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = message.type;
                        if (message.data && message.data.length) {
                            object.data = [];
                            for (let j = 0; j < message.data.length; ++j)
                                object.data[j] = options.bytes === String ? $util.base64.encode(message.data[j], 0, message.data[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.data[j]) : message.data[j];
                        }
                        if (message.error && message.error.length) {
                            object.error = [];
                            for (let j = 0; j < message.error.length; ++j)
                                object.error[j] = $root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Error.toObject(message.error[j], options);
                        }
                        if (message.warning && message.warning.length) {
                            object.warning = [];
                            for (let j = 0; j < message.warning.length; ++j)
                                object.warning[j] = $root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning.toObject(message.warning[j], options);
                        }
                        if (message.version != null && message.hasOwnProperty("version"))
                            object.version = message.version;
                        if (message.single != null && message.hasOwnProperty("single"))
                            object.single = message.single;
                        return object;
                    };

                    /**
                     * Converts this ResponseEnvelope to JSON.
                     * @function toJSON
                     * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ResponseEnvelope.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    ResponseEnvelope.Error = (function() {

                        /**
                         * Properties of an Error.
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                         * @interface IError
                         * @property {string|null} [title] Error title
                         * @property {string|null} [message] Error message
                         */

                        /**
                         * Constructs a new Error.
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                         * @classdesc Represents an Error.
                         * @implements IError
                         * @constructor
                         * @param {at.hotelmeister.protobuf.backend.ResponseEnvelope.IError=} [properties] Properties to set
                         */
                        function Error(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Error title.
                         * @member {string} title
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Error
                         * @instance
                         */
                        Error.prototype.title = "";

                        /**
                         * Error message.
                         * @member {string} message
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Error
                         * @instance
                         */
                        Error.prototype.message = "";

                        /**
                         * Creates a new Error instance using the specified properties.
                         * @function create
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Error
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.ResponseEnvelope.IError=} [properties] Properties to set
                         * @returns {at.hotelmeister.protobuf.backend.ResponseEnvelope.Error} Error instance
                         */
                        Error.create = function create(properties) {
                            return new Error(properties);
                        };

                        /**
                         * Encodes the specified Error message. Does not implicitly {@link at.hotelmeister.protobuf.backend.ResponseEnvelope.Error.verify|verify} messages.
                         * @function encode
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Error
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.ResponseEnvelope.IError} message Error message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Error.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.title);
                            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                            return writer;
                        };

                        /**
                         * Encodes the specified Error message, length delimited. Does not implicitly {@link at.hotelmeister.protobuf.backend.ResponseEnvelope.Error.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Error
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.ResponseEnvelope.IError} message Error message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Error.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes an Error message from the specified reader or buffer.
                         * @function decode
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Error
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {at.hotelmeister.protobuf.backend.ResponseEnvelope.Error} Error
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Error.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Error();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.title = reader.string();
                                    break;
                                case 2:
                                    message.message = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes an Error message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Error
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {at.hotelmeister.protobuf.backend.ResponseEnvelope.Error} Error
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Error.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies an Error message.
                         * @function verify
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Error
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Error.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.title != null && message.hasOwnProperty("title"))
                                if (!$util.isString(message.title))
                                    return "title: string expected";
                            if (message.message != null && message.hasOwnProperty("message"))
                                if (!$util.isString(message.message))
                                    return "message: string expected";
                            return null;
                        };

                        /**
                         * Creates an Error message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Error
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {at.hotelmeister.protobuf.backend.ResponseEnvelope.Error} Error
                         */
                        Error.fromObject = function fromObject(object) {
                            if (object instanceof $root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Error)
                                return object;
                            let message = new $root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Error();
                            if (object.title != null)
                                message.title = String(object.title);
                            if (object.message != null)
                                message.message = String(object.message);
                            return message;
                        };

                        /**
                         * Creates a plain object from an Error message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Error
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.ResponseEnvelope.Error} message Error
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Error.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.title = "";
                                object.message = "";
                            }
                            if (message.title != null && message.hasOwnProperty("title"))
                                object.title = message.title;
                            if (message.message != null && message.hasOwnProperty("message"))
                                object.message = message.message;
                            return object;
                        };

                        /**
                         * Converts this Error to JSON.
                         * @function toJSON
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Error
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Error.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        return Error;
                    })();

                    ResponseEnvelope.Warning = (function() {

                        /**
                         * Properties of a Warning.
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                         * @interface IWarning
                         * @property {string|null} [title] Warning title
                         * @property {string|null} [message] Warning message
                         */

                        /**
                         * Constructs a new Warning.
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope
                         * @classdesc Represents a Warning.
                         * @implements IWarning
                         * @constructor
                         * @param {at.hotelmeister.protobuf.backend.ResponseEnvelope.IWarning=} [properties] Properties to set
                         */
                        function Warning(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Warning title.
                         * @member {string} title
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning
                         * @instance
                         */
                        Warning.prototype.title = "";

                        /**
                         * Warning message.
                         * @member {string} message
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning
                         * @instance
                         */
                        Warning.prototype.message = "";

                        /**
                         * Creates a new Warning instance using the specified properties.
                         * @function create
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.ResponseEnvelope.IWarning=} [properties] Properties to set
                         * @returns {at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning} Warning instance
                         */
                        Warning.create = function create(properties) {
                            return new Warning(properties);
                        };

                        /**
                         * Encodes the specified Warning message. Does not implicitly {@link at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning.verify|verify} messages.
                         * @function encode
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.ResponseEnvelope.IWarning} message Warning message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Warning.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.title);
                            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                            return writer;
                        };

                        /**
                         * Encodes the specified Warning message, length delimited. Does not implicitly {@link at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.ResponseEnvelope.IWarning} message Warning message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Warning.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a Warning message from the specified reader or buffer.
                         * @function decode
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning} Warning
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Warning.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.title = reader.string();
                                    break;
                                case 2:
                                    message.message = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a Warning message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning} Warning
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Warning.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a Warning message.
                         * @function verify
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Warning.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.title != null && message.hasOwnProperty("title"))
                                if (!$util.isString(message.title))
                                    return "title: string expected";
                            if (message.message != null && message.hasOwnProperty("message"))
                                if (!$util.isString(message.message))
                                    return "message: string expected";
                            return null;
                        };

                        /**
                         * Creates a Warning message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning} Warning
                         */
                        Warning.fromObject = function fromObject(object) {
                            if (object instanceof $root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning)
                                return object;
                            let message = new $root.at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning();
                            if (object.title != null)
                                message.title = String(object.title);
                            if (object.message != null)
                                message.message = String(object.message);
                            return message;
                        };

                        /**
                         * Creates a plain object from a Warning message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning} message Warning
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Warning.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.title = "";
                                object.message = "";
                            }
                            if (message.title != null && message.hasOwnProperty("title"))
                                object.title = message.title;
                            if (message.message != null && message.hasOwnProperty("message"))
                                object.message = message.message;
                            return object;
                        };

                        /**
                         * Converts this Warning to JSON.
                         * @function toJSON
                         * @memberof at.hotelmeister.protobuf.backend.ResponseEnvelope.Warning
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Warning.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        return Warning;
                    })();

                    return ResponseEnvelope;
                })();

                backend.RequestEnvelope = (function() {

                    /**
                     * Properties of a RequestEnvelope.
                     * @memberof at.hotelmeister.protobuf.backend
                     * @interface IRequestEnvelope
                     * @property {Array.<at.hotelmeister.protobuf.backend.RequestEnvelope.IArgument>|null} [args] RequestEnvelope args
                     */

                    /**
                     * Constructs a new RequestEnvelope.
                     * @memberof at.hotelmeister.protobuf.backend
                     * @classdesc Represents a RequestEnvelope.
                     * @implements IRequestEnvelope
                     * @constructor
                     * @param {at.hotelmeister.protobuf.backend.IRequestEnvelope=} [properties] Properties to set
                     */
                    function RequestEnvelope(properties) {
                        this.args = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * RequestEnvelope args.
                     * @member {Array.<at.hotelmeister.protobuf.backend.RequestEnvelope.IArgument>} args
                     * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope
                     * @instance
                     */
                    RequestEnvelope.prototype.args = $util.emptyArray;

                    /**
                     * Creates a new RequestEnvelope instance using the specified properties.
                     * @function create
                     * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.IRequestEnvelope=} [properties] Properties to set
                     * @returns {at.hotelmeister.protobuf.backend.RequestEnvelope} RequestEnvelope instance
                     */
                    RequestEnvelope.create = function create(properties) {
                        return new RequestEnvelope(properties);
                    };

                    /**
                     * Encodes the specified RequestEnvelope message. Does not implicitly {@link at.hotelmeister.protobuf.backend.RequestEnvelope.verify|verify} messages.
                     * @function encode
                     * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.IRequestEnvelope} message RequestEnvelope message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RequestEnvelope.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.args != null && message.args.length)
                            for (let i = 0; i < message.args.length; ++i)
                                $root.at.hotelmeister.protobuf.backend.RequestEnvelope.Argument.encode(message.args[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified RequestEnvelope message, length delimited. Does not implicitly {@link at.hotelmeister.protobuf.backend.RequestEnvelope.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.IRequestEnvelope} message RequestEnvelope message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RequestEnvelope.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a RequestEnvelope message from the specified reader or buffer.
                     * @function decode
                     * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {at.hotelmeister.protobuf.backend.RequestEnvelope} RequestEnvelope
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RequestEnvelope.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.at.hotelmeister.protobuf.backend.RequestEnvelope();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.args && message.args.length))
                                    message.args = [];
                                message.args.push($root.at.hotelmeister.protobuf.backend.RequestEnvelope.Argument.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a RequestEnvelope message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {at.hotelmeister.protobuf.backend.RequestEnvelope} RequestEnvelope
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RequestEnvelope.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a RequestEnvelope message.
                     * @function verify
                     * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RequestEnvelope.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.args != null && message.hasOwnProperty("args")) {
                            if (!Array.isArray(message.args))
                                return "args: array expected";
                            for (let i = 0; i < message.args.length; ++i) {
                                let error = $root.at.hotelmeister.protobuf.backend.RequestEnvelope.Argument.verify(message.args[i]);
                                if (error)
                                    return "args." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a RequestEnvelope message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {at.hotelmeister.protobuf.backend.RequestEnvelope} RequestEnvelope
                     */
                    RequestEnvelope.fromObject = function fromObject(object) {
                        if (object instanceof $root.at.hotelmeister.protobuf.backend.RequestEnvelope)
                            return object;
                        let message = new $root.at.hotelmeister.protobuf.backend.RequestEnvelope();
                        if (object.args) {
                            if (!Array.isArray(object.args))
                                throw TypeError(".at.hotelmeister.protobuf.backend.RequestEnvelope.args: array expected");
                            message.args = [];
                            for (let i = 0; i < object.args.length; ++i) {
                                if (typeof object.args[i] !== "object")
                                    throw TypeError(".at.hotelmeister.protobuf.backend.RequestEnvelope.args: object expected");
                                message.args[i] = $root.at.hotelmeister.protobuf.backend.RequestEnvelope.Argument.fromObject(object.args[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a RequestEnvelope message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope
                     * @static
                     * @param {at.hotelmeister.protobuf.backend.RequestEnvelope} message RequestEnvelope
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RequestEnvelope.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.args = [];
                        if (message.args && message.args.length) {
                            object.args = [];
                            for (let j = 0; j < message.args.length; ++j)
                                object.args[j] = $root.at.hotelmeister.protobuf.backend.RequestEnvelope.Argument.toObject(message.args[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this RequestEnvelope to JSON.
                     * @function toJSON
                     * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RequestEnvelope.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    RequestEnvelope.Argument = (function() {

                        /**
                         * Properties of an Argument.
                         * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope
                         * @interface IArgument
                         * @property {string|null} [key] Argument key
                         * @property {string|null} [value] Argument value
                         */

                        /**
                         * Constructs a new Argument.
                         * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope
                         * @classdesc Represents an Argument.
                         * @implements IArgument
                         * @constructor
                         * @param {at.hotelmeister.protobuf.backend.RequestEnvelope.IArgument=} [properties] Properties to set
                         */
                        function Argument(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Argument key.
                         * @member {string} key
                         * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope.Argument
                         * @instance
                         */
                        Argument.prototype.key = "";

                        /**
                         * Argument value.
                         * @member {string} value
                         * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope.Argument
                         * @instance
                         */
                        Argument.prototype.value = "";

                        /**
                         * Creates a new Argument instance using the specified properties.
                         * @function create
                         * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope.Argument
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.RequestEnvelope.IArgument=} [properties] Properties to set
                         * @returns {at.hotelmeister.protobuf.backend.RequestEnvelope.Argument} Argument instance
                         */
                        Argument.create = function create(properties) {
                            return new Argument(properties);
                        };

                        /**
                         * Encodes the specified Argument message. Does not implicitly {@link at.hotelmeister.protobuf.backend.RequestEnvelope.Argument.verify|verify} messages.
                         * @function encode
                         * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope.Argument
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.RequestEnvelope.IArgument} message Argument message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Argument.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
                            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);
                            return writer;
                        };

                        /**
                         * Encodes the specified Argument message, length delimited. Does not implicitly {@link at.hotelmeister.protobuf.backend.RequestEnvelope.Argument.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope.Argument
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.RequestEnvelope.IArgument} message Argument message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Argument.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes an Argument message from the specified reader or buffer.
                         * @function decode
                         * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope.Argument
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {at.hotelmeister.protobuf.backend.RequestEnvelope.Argument} Argument
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Argument.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.at.hotelmeister.protobuf.backend.RequestEnvelope.Argument();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.key = reader.string();
                                    break;
                                case 2:
                                    message.value = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes an Argument message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope.Argument
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {at.hotelmeister.protobuf.backend.RequestEnvelope.Argument} Argument
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Argument.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies an Argument message.
                         * @function verify
                         * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope.Argument
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Argument.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.key != null && message.hasOwnProperty("key"))
                                if (!$util.isString(message.key))
                                    return "key: string expected";
                            if (message.value != null && message.hasOwnProperty("value"))
                                if (!$util.isString(message.value))
                                    return "value: string expected";
                            return null;
                        };

                        /**
                         * Creates an Argument message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope.Argument
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {at.hotelmeister.protobuf.backend.RequestEnvelope.Argument} Argument
                         */
                        Argument.fromObject = function fromObject(object) {
                            if (object instanceof $root.at.hotelmeister.protobuf.backend.RequestEnvelope.Argument)
                                return object;
                            let message = new $root.at.hotelmeister.protobuf.backend.RequestEnvelope.Argument();
                            if (object.key != null)
                                message.key = String(object.key);
                            if (object.value != null)
                                message.value = String(object.value);
                            return message;
                        };

                        /**
                         * Creates a plain object from an Argument message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope.Argument
                         * @static
                         * @param {at.hotelmeister.protobuf.backend.RequestEnvelope.Argument} message Argument
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Argument.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.key = "";
                                object.value = "";
                            }
                            if (message.key != null && message.hasOwnProperty("key"))
                                object.key = message.key;
                            if (message.value != null && message.hasOwnProperty("value"))
                                object.value = message.value;
                            return object;
                        };

                        /**
                         * Converts this Argument to JSON.
                         * @function toJSON
                         * @memberof at.hotelmeister.protobuf.backend.RequestEnvelope.Argument
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Argument.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        return Argument;
                    })();

                    return RequestEnvelope;
                })();

                return backend;
            })();

            return protobuf;
        })();

        return hotelmeister;
    })();

    return at;
})();

export { $root as default };



// WEBPACK FOOTER //
// ./src/protobuf/index.js